import { Prediction } from "@/app/@types";
import { supabase } from "../supabase-client";

export const createPrediction = async (
  userId: string,
  prediction: Omit<Prediction, "id" | "created_at">
): Promise<Prediction | null> => {
  try {
    if (!userId) {
      console.error("User ID is required for creating prediction");
      return null;
    }

    const { data, error } = await supabase
      .from("predictions")
      .insert({
        user_id: userId,
        question: prediction.question,
        prediction: prediction.prediction,
        confidence: prediction.confidence,
        reasoning: prediction.reasoning,
        bias_check: prediction.bias_check,
        status: prediction.status,
        points_earned: prediction.points_earned,
      })
      .select()
      .single();

    if (error) {
      console.error("Error creating prediction:", error);
      return null;
    }

    if (!data) {
      console.error("No data returned after creating prediction");
      return null;
    }

    return { ...data, user_email: prediction.user_email };
    
  } catch (error) {
    console.error("Unexpected error creating prediction:", error);
    return null;
  }
};